module.exports = __webpack_public_path__ + "e825ba8b249c353ee04ac1e6f4cd3814.png";